module.exports = __webpack_public_path__ + "img/setting-footer.58db44f.svg";